<style scoped>
.v-application .subtitle-1 {
  font-family: "Prompt", sans-serif !important;
}
.v-application .text-h5 {
  font-family: "Prompt", sans-serif !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-data-table__wrapper > table > thead > tr {
  background-color: #039be5;
}
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  color: white !important;
}
.v-input__slot {
  min-height: unset !important;
}
.email-text {
  font-size: 16px;
  font-weight: bold;
}
.handle {
  cursor: move;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between mb-5">
      <div
        class="text-h5 font-weight-black info--text text-spacing"
        color="blue"
      >
        ใบเสนอราคาเลขที่ {{ header }}
      </div>
      <v-spacer></v-spacer>
      <v-btn color="white" elevation="0" large @click="back()" class="mr-4"
        >ยกเลิก</v-btn
      >
      <!--  -->
      <v-dialog v-model="dialog" max-width="640">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="success"
            elevation="0"
            large
            dark
            v-bind="attrs"
            v-on="on"
            v-if="!isEdit"
          >
            <v-icon left>mdi-file-plus</v-icon>บันทึกเอกสาร
          </v-btn>
        </template>
        <v-card>
          <v-card-title
            class="text-h5 font-weight-black info--text text-spacing"
            color="blue"
          >
            บันทึกเอกสาร {{ header }}
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row justify="center">
              <v-radio-group
                row
                class="mb-n5"
                v-model="sendOrsave"
                @change="genEmailDetail()"
              >
                <v-radio
                  class="pr-6"
                  label="บันทึกข้อมูลอย่างเดียว"
                  hide-details
                  value="NSEND"
                ></v-radio>
                <v-radio
                  class="pr-6"
                  label="ส่งอีเมลล์พร้อมกับบันทึก"
                  hide-details
                  value="SEND"
                ></v-radio>
              </v-radio-group>

              <v-col cols="12" lg="12" v-if="sendOrsave == 'SEND'">
                <v-row justify="center">
                  <v-col cols="12" lg="10" class="mb-n10 mt-n5">
                    <span class="email-text">จาก :</span>
                    <v-text-field
                      dense
                      outlined
                      v-model="Esender"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="10" class="mb-n10">
                    <span class="email-text">ถึง :</span>
                    <v-text-field
                      dense
                      outlined
                      v-model="Ereciever"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="10" class="mb-n10">
                    <span class="email-text">หัวข้อ :</span>
                    <v-text-field
                      dense
                      outlined
                      v-model="Eheader"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="10" class="my-n2">
                    <!-- <v-radio-group row v-model="checkReciept">
                      <v-radio
                        class="pr-6"
                        label="ส่งใบแจ้งหนี้ / ใบเสนอราคา"
                        hide-details
                        value="WR"
                      ></v-radio>
                      <v-radio
                        class="pr-6"
                        label="ส่งใบเสนอราคา"
                        hide-details
                        value="NR"
                      ></v-radio>
                    </v-radio-group> -->
                  </v-col>
                  <v-col cols="12" lg="10" class="mt-n2">
                    <span class="email-text">ข้อความ :</span>
                    <v-textarea
                      row-height="5"
                      dense
                      outlined
                      v-model="Emessage"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" lg="10" class="mt-n5">
                    <v-btn color="primary" width="100%" @click="sendemail()">
                      ส่งอีเมลล์พร้อมกับบันทึก
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="12" v-else>
                <v-btn color="success" width="100%" @click="save()">
                  บันทึกข้อมูล
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-btn
        color="success"
        elevation="0"
        large
        dark
        @click="edit()"
        v-if="isEdit"
      >
        <v-icon left>mdi-file-plus</v-icon>แก้ไขเอกสาร
      </v-btn>
    </v-layout>
    <v-divider class="mt-n1 mb-3"></v-divider>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-layout class="d-flex justify-space-between mb-15">
        <v-row>
          <!-- :items="Find_CustomerName" -->
          <v-col cols="12" lg="4" class="mb-n8">
            <v-combobox
              :disabled="isEdit"
              label="เลือกลูกค้า"
              dense
              outlined
              :items="list_customer"
              item-text="CUSTOMER_NAME"
              item-value="NEWCUSTOMER_ID"
              return-object
              required
              v-model="vCustomer_Name"
              @change="(event) => select_customer(event)"
            ></v-combobox>
          </v-col>
          <v-col cols="12" lg="8" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="4" class="mb-n10">
            <v-text-field
              label="เลขประจำตัวผู้เสียภาษี"
              dense
              outlined
              v-model="vCustomer_Tax"
              :disabled="isEdit"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="8" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="4" class="mb-n10">
            <v-text-field
              label="สำนักงาน / สาขาเลขที่"
              dense
              outlined
              v-model="vCustomer_Branch"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="8" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="4" class="mb-n10">
            <v-text-field
              label="ที่อยู่"
              dense
              outlined
              v-model="vcus_address"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="8" class="mb-n7">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="2" class="mb-n7">
            <addressinput-subdistrict v-model="cus_pro" />
          </v-col>
          <!-- <v-col cols="12" lg="8" class="mb-n7">
            <v-spacer></v-spacer>
          </v-col>-->
          <v-col cols="12" lg="2" class="mb-n7">
            <addressinput-district v-model="cus_dis" />
          </v-col>
          <v-col cols="12" lg="8" class="mb-n7">
            <v-spacer></v-spacer>
          </v-col>

          <v-col cols="12" lg="2" class="mb-n7">
            <addressinput-province v-model="cus_subdis" />
          </v-col>
          <v-col cols="12" lg="2" class="mb-n7">
            <addressinput-zipcode v-model="cus_zip" />
          </v-col>
          <v-col cols="12" lg="8">
            <v-spacer></v-spacer>
          </v-col>

          <!-- <v-col cols="12" lg="6" class="mb-n10">
            <v-text-field label="รหัสไปรษณีย์" dense single-line outlined></v-text-field>
          </v-col>-->
          <!-- <v-col cols="12" lg="6" class="mb-n11">
            <v-spacer></v-spacer>
          </v-col>-->
        </v-row>
        <v-spacer></v-spacer>

        <v-row style="justify-content: flex-end">
          <v-col cols="12" lg="12" class="mb-2">
            <v-layout class="d-flex flex-row-reverse mb-n15">
              <div class="d-flex flex-column align-center" style="width: 80px">
                <v-btn icon height="30" xLarge>
                  <v-icon>mdi-email-send-outline</v-icon>
                </v-btn>
                <p class="mb-0" style="font-size: 12px">ส่งอีเมลล์</p>
              </div>
              <div class="d-flex flex-column align-center" style="width: 80px">
                <v-btn icon height="30" xLarge @click="downloadPdf()">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <p class="mb-0" style="font-size: 12px">ดาวน์โหลด</p>
              </div>
              <div class="d-flex flex-column align-center" style="width: 80px">
                <v-dialog v-model="dialog2" max-width="550">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon height="30" xLarge v-bind="attrs" v-on="on">
                      <v-icon>mdi-printer</v-icon>
                    </v-btn>
                    <p class="mb-0" style="font-size: 12px">พิมพ์เอกสาร</p>
                  </template>
                  <v-card>
                    <v-card-title
                      class="text-h5 font-weight-black info--text text-spacing"
                      color="blue"
                    >
                      พิมพ์เอกสาร {{ header }}
                    </v-card-title>
                    <v-card-text>
                      <v-divider></v-divider>
                      <v-row justify="center">
                        <v-col cols="12" lg="12">
                          <v-radio-group
                            row
                            class="mb-n5"
                            v-model="checkReciept"
                          >
                            <!-- <v-radio
                              class="pr-6"
                              label="พิมพ์ใบแจ้งหนี้ / ใบเสนอราคา"
                              hide-details
                              value="WR"
                            ></v-radio>
                            <v-radio
                              class="pr-6"
                              label="พิมพ์ใบเสนอราคา"
                              hide-details
                              value="NR"
                            ></v-radio> -->
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" lg="12">
                          <v-btn
                            color="primary"
                            width="100%"
                            @click="printPdf()"
                          >
                            พิมพ์เอกสาร
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
            </v-layout>
          </v-col>

          <v-col cols="12" lg="8">
            <div class="subtitle-1 font-weight-bold">จำนวนรวมทั้งสิ้น</div>
            <div class="text-h5 info--text font-weight-bold">
              {{ totalVat7 | delimeter }}
            </div>
          </v-col>
          <v-col cols="12" lg="2">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="4" class="my-n9 text-right">
            <div class="subtitle-1 font-weight-bold">วันที่</div>
          </v-col>
          <v-col cols="12" lg="8" class="my-n10 text-right">
            <date-picker
              color="black"
              class="mb-1"
              style="width: 100%"
              v-model="con_date"
              :format="momentFormat"
              :disabled="isEdit"
            ></date-picker>
          </v-col>
          <v-col cols="12" lg="4" class="my-n15 text-right"> </v-col>
          <v-col cols="12" lg="8" class="my-n15 text-right">
            <v-checkbox
              label="แบ่งจ่าย"
              v-model="split_pay"
              :disabled="isEdit"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-layout>
      <v-divider class="mt-n1 mb-3"></v-divider>
      <v-row>
        <v-col cols="12" lg="1">
          <div class="subtitle-1 font-weight-bold mt-1">ชื่อโปรเจค</div>
        </v-col>
        <v-col cols="12" lg="7">
          <v-text-field outlined dense v-model="vcus_memo"></v-text-field>
        </v-col>
        <v-col cols="12" lg="1">
          <div class="subtitle-1 font-weight-bold mt-1">ราคาสินค้า</div>
        </v-col>
        <v-col cols="12" lg="3">
          <v-select
            label="เลือกราคา"
            :items="pricing"
            dense
            outlined
            v-model="price_op"
            @change="(event) => price_option(event)"
            :disabled="isEdit"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="12" class="mt-n3">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 3%">ลำดับ</th>
                  <th class="text-left" style="width: 55%">
                    ชื่อสินค้า / รายละเอียด
                  </th>
                  <th class="text-left" style="width: 3%">จำนวน</th>
                  <th class="text-left" style="width: 3%">หน่วย</th>
                  <th class="text-left" style="width: 12%">ราคาต่อหน่วย</th>
                  <th class="text-left" style="width: 12%">ราคารวม</th>
                  <th class="text-center" style="width: 2%"></th>
                </tr>
              </thead>

              <draggable
                :list="product_list"
                tag="tbody"
                :move="onMove(product_list)"
              >
                <tr
                  v-for="(item, index) in product_list"
                  :key="index"
                  class="sortableRow sortHandle handle"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <v-menu offset-y :disabled="isEdit">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :disabled="isEdit"
                          v-on="on"
                          clearable
                          placeholder="สินค้า"
                          flat
                          class="mt-2 mb-1"
                          dense
                          v-model="product_list[index].NAME"
                          @keyup="search = $event.target.value"
                          @click:clear="clearSearch()"
                        ></v-text-field>
                      </template>
                      <v-list style="max-height: 200px; overflow: auto">
                        <v-list-item
                          v-for="(item, i) in filteredItems"
                          :key="i"
                          @click="select_combo(index, item)"
                        >
                          <v-list-item-title>{{ item.NAME }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                      <!-- <v-card>
                        <v-divider></v-divider>
                        <div class="pa-1" @click.stop>
                          <v-btn
                            text
                            dark
                            small
                            color="primary"
                            depressed
                            :ripple="false"
                            style="width: 100%; justify-content: start"
                          >
                            <v-icon left>mdi-plus</v-icon>เพิ่มสินค้า
                          </v-btn>
                        </div>
                      </v-card> -->
                    </v-menu>
                    <v-textarea
                      placeholder="รายละเอียด"
                      dense
                      outlined
                      rows="1"
                      row-height="5"
                      auto-grow
                      class="my-n4"
                      v-model="product_list[index].DETAIL"
                    ></v-textarea>
                  </td>
                  <td>
                    <v-text-field
                      dense
                      :disabled="isEdit"
                      class="mt-3"
                      type="number"
                      v-model="product_list[index].AMOUT"
                      @keyup="changeUnit()"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      dense
                      class="mt-3"
                      :disabled="isEdit"
                      v-model="product_list[index].UNIT"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      dense
                      class="mt-3"
                      :disabled="isEdit"
                      v-model="product_list[index].PRICE"
                      @keyup="changePrice()"
                    ></v-text-field>
                  </td>
                  <td style="font-size: 1rem">
                    {{ sumCol(index) | delimeter }}
                  </td>
                  <td>
                    <v-btn icon @click="delete_product(item)" v-if="!isEdit">
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </draggable>

              <v-spacer></v-spacer>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="12" lg="3">
          <v-btn
            color="info"
            elevation="0"
            large
            @click="add_product()"
            v-if="!isEdit"
          >
            <v-icon left>mdi-plus</v-icon>เพิ่มแถวรายการ
          </v-btn>
        </v-col>
      </v-row>

      <v-layout class="d-flex justify-space-between mb-15">
        <v-row>
          <v-col cols="12" lg="12" class="mb-n2">
            <div class="subtitle-1 font-weight-bold">หมายเหตุ</div>
          </v-col>
          <v-col cols="12" lg="12" class="my-n5">
            <v-textarea
              label
              outlined
              rows="3"
              row-height="25"
              v-model="remark"
            ></v-textarea>
          </v-col>
          <!-- <v-col cols="12" lg="3" class="my-n5">
            <v-spacer></v-spacer>
          </v-col>-->
          <!-- <v-col cols="12" lg="12" class="my-n2">
            <div class="subtitle-1 font-weight-bold">โน๊ตภายในบริษัท</div>
          </v-col>
          <v-col cols="12" lg="7" class="my-n5">
            <v-textarea label outlined rows="3" row-height="25"></v-textarea>
          </v-col>
          <v-col cols="12" lg="5" class="my-n5">
            <v-spacer></v-spacer>
          </v-col>
          <v-col cols="12" lg="7" class="my-n5">
            <v-text-field outlined label="แนบไฟล์" dense prepend-inner-icon="mdi-plus"></v-text-field>
          </v-col>
          <v-col cols="12" lg="5" class="my-n5">
            <v-spacer></v-spacer>
          </v-col>-->
          <!-- <v-col cols="12" lg="12" class="my-n8">
            <v-checkbox label="ลายเซ็นอิเล็กทรอนิกส์และตรายาง" v-model="signature"></v-checkbox>
          </v-col>-->
        </v-row>

        <v-spacer></v-spacer>

        <v-row style="justify-content: flex-end; width: 100%">
          <v-col cols="12" lg="12" class="my-n10 text-right">
            <div class="d-flex flex-column mb-6">
              <div class="d-flex flex-row-reverse">
                <div class="subtitle-1 font-weight-bold ml-15 my-1">
                  {{ summary | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 my-1">
                  รวมเป็นเงิน
                </div>
              </div>
              <div
                class="d-flex flex-row-reverse"
                v-if="vat_option == 'ราคารวมภาษี'"
              >
                <div class="subtitle-1 font-weight-bold ml-15 my-1">
                  {{ totalVat7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 my-1">
                  จำนวนเงินรวมทั้งสิ้น
                </div>
              </div>

              <div class="d-flex flex-row-reverse">
                <div class="subtitle-1 font-weight-bold ml-15 my-5">
                  {{ onlyVat7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  <v-checkbox
                    label="ภาษีมูลค่าเพิ่ม 7%"
                    v-model="vat7"
                    v-if="vat_option == 'ราคาไม่รวมภาษี'"
                    @change="(evt) => checked_vat7(evt)"
                    :disabled="isEdit"
                  ></v-checkbox>
                  <div class="mt-4" v-else-if="vat_option == 'ราคารวมภาษี'">
                    ภาษีมูลค่าเพิ่ม 7%
                  </div>
                  <!-- <v-checkbox label="ภาษีมูลค่าเพิ่ม 7%" v-model="vat7" v-else></v-checkbox> -->
                </div>
              </div>
              <div
                class="d-flex flex-row-reverse"
                v-if="vat_option == 'ราคารวมภาษี'"
              >
                <div class="subtitle-1 font-weight-bold ml-15 my-1">
                  {{ exclude_7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15 my-1">
                  ราคาไม่รวมภาษีมูลค่าเพิ่ม
                </div>
              </div>

              <div
                class="d-flex flex-row-reverse"
                v-if="vat_option == 'ราคาไม่รวมภาษี'"
              >
                <div class="subtitle-1 font-weight-bold ml-15">
                  {{ totalVat7 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  จำนวนเงินรวมทั้งสิ้น
                </div>
              </div>
              <div class="d-flex flex-row-reverse">
                <div class="subtitle-1 font-weight-bold ml-15 my-5">
                  <span v-if="isVat3"> {{ onlyVat3 | delimeter }}</span>
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  <v-row align="center">
                    <v-checkbox
                      label="หักภาษี ณ ที่จ่าย"
                      v-model="vat3"
                      @change="(evt) => checked_vat3(evt)"
                      :disabled="isEdit"
                    ></v-checkbox>
                    <v-select
                      v-if="isVat3"
                      dense
                      :items="se_vat3"
                      style="width: 80px"
                      class="mt-2 ml-2"
                      v-model="vat3_value"
                      :disabled="isEdit"
                      @change="(evt) => vat3_option(evt)"
                    ></v-select>
                  </v-row>
                </div>
              </div>
              <div class="d-flex flex-row-reverse" v-if="isVat3">
                <div class="subtitle-1 font-weight-bold ml-15">
                  {{ summaryVat3 | delimeter }}
                </div>
                <div class="subtitle-1 font-weight-bold info--text mr-15">
                  ยอดชำระ
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import quotation_pdf from "../pdf/quotation";
import { mapMutations, mapGetters } from 'vuex'
import draggable from "vuedraggable";
import moment from 'moment';
export default {
  name: "QuotationForm",
  components: {
    draggable,
  },
  data: () => ({
    // product_list: [],
    isEdit: false,
    Esender: "newchok.2019@gmail.com",
    Emessage: "",
    previousRoute: "",
    Eheader: "",
    header: "",
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    checkReciept: "",
    sendOrsave: "NSEND",
    enabled_tax: false,
    enabled_c_date: false,
    v_cal_tax: [(v) => !!v || ""],
    v_percent_tax: [(v) => !!v || ""],
    v_collect_date: [(v) => !!v || ""],
    v_waste_document: [(v) => !!v || ""],
    v_c_period: [(v) => !!v || "กรุณาเลือกจำนวนปี"],
    v_hopsname: [(v) => !!v || "กรุณากรอกสถานบริการ"],
    v_c_start: [(v) => !!v || "กรุณาเลือกวันที่ทำสัญญา"],
    v_c_type: [(v) => !!v || "กรุณาเลือกอัตราการจัดเก็บขยะ"],
    contract_period: [],
    se_vat3: ["3%", "5%", "0.5%", "0.75%", "1%"],
    list_customer: [],
    pricing: ["ราคาไม่รวมภาษี"],
    product: [],
    search: "",
    vat_option: "ราคาไม่รวมภาษี",
    isVat3: false,
    summaryVat3: 0,
    dialog: false,
    totalVat7: 0,
    onlyVat7: 0,
    onlyVat3: 0,
    summary: 0.0,
    exclude_7: 0,
    dialog2: false,
    valid: true,
    lazy: false,
    se_contract: "",
    c_type: ["เหมาจ่ายรายปี", "เหมาจ่ายรายเดือน", "คิดเป็นหน่วย / กิโลกรัม"],
    valid: true,
    lazy: false,
    Find_CustomerName: "",

  }),
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2)
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x

    },
    formatDate(data) {
      return moment(data).format('DD-MM-YYYY')
    }
  },

  computed: {
    filteredItems() {
      let searchRegExp = new RegExp(this.search, "gi");
      return this.product.filter((item) => {
        if (!this.search) {
          return this.product;
        } else {
          return searchRegExp.test(item.NAME);
        }
      });
    },
    ...mapGetters({
      GET_QUOTATION: 'Quotation/GET_QUOTATION',
    }),
    product_list() {
      let vat3 = this.GET_QUOTATION['ISVAT2'];
      let vat7 = this.GET_QUOTATION['ISVAT'];
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
      let list_product = this.$store.getters["Quotation/GET_PRODUCT"];
      list_product.filter((x) => { return x.PRICE == null }).map((item) => { return item.PRICE = 0 });
      return list_product;
    },
    split_pay: {
      get() {
        return this.GET_QUOTATION.SPLIT_PAY;
      },
      set(value) {
        this.SET_ALL({
          key: "SPLIT_PAY",
          value: value,
        });
      },
    },
    Ereciever: {
      get() {
        return this.GET_QUOTATION.PROVIDER_EMAIL;
      },
      set(value) {
        this.SET_ALL({
          key: "PROVIDER_EMAIL",
          value: value,
        });
      },
    },
    vcus_memo: {
      get() {
        return this.GET_QUOTATION.MEMO;
      },
      set(value) {
        this.SET_ALL({
          key: "MEMO",
          value: value,
        });
      },
    },
    vcus_address: {
      get() {
        return this.GET_QUOTATION.CUSTOMER_ADDRESS;
      },
      set(value) {
        this.SET_ALL({
          key: "CUSTOMER_ADDRESS",
          value: value,
        });
      },
    },
    price_op: {
      get() {
        return this.GET_QUOTATION.PRICE_OPTION;
      },
      set(value) {
        this.SET_ALL({
          key: "PRICE_OPTION",
          value: value,
        });
      },
    },
    remark: {
      get() {
        return this.GET_QUOTATION.REMARK;
      },
      set(value) {
        this.SET_ALL({
          key: "REMARK",
          value: value,
        });
      },
    },
    vat7: {
      get() {

        return this.GET_QUOTATION['ISVAT'];
      },
      set(value) {
        this.SET_ALL({
          key: "ISVAT",
          value: value,
        });
      },
    },
    vat7_value: {
      get() {

        return this.GET_QUOTATION.VAT_VALUE;
      },
      set(value) {
        this.SET_ALL({
          key: "VAT_VALUE",
          value: value,
        });
      },
    },
    vat3: {
      get() {

        return this.GET_QUOTATION['ISVAT2'];
      },
      set(value) {
        this.SET_ALL({
          key: "ISVAT2",
          value: value,
        });
      },
    },
    vat3_value: {
      get() {
        return this.GET_QUOTATION.VAT_VALUE2;
      },
      set(value) {
        this.SET_ALL({
          key: "VAT_VALUE2",
          value: value,
        });
      },
    },
    signature: {
      get() {
        return this.GET_QUOTATION.SIGNATURE;
      },
      set(value) {
        this.SET_ALL({
          key: "SIGNATURE",
          value: value,
        });
      },
    },
    con_date: {
      get() {
        return this.GET_QUOTATION.CREATED_AT ? new Date(this.GET_QUOTATION.CREATED_AT) : new Date();
      },
      set(value) {
        this.SET_ALL({
          key: "CREATED_AT",
          value: value,
        });


      },
    },
    cus_pro: {
      get() {
        return this.GET_QUOTATION.CUSTOMER_PROVINCE;
      },
      set(value) {
        this.SET_ALL({
          key: "CUSTOMER_PROVINCE",
          value: value,
        });
      },
    },
    cus_dis: {
      get() {
        return this.GET_QUOTATION.CUSTOMER_DISTRICT;
      },
      set(value) {
        this.SET_ALL({
          key: "CUSTOMER_DISTRICT",
          value: value,
        });
      },
    },
    cus_subdis: {
      get() {
        return this.GET_QUOTATION
          .CUSTOMER_SUBDISTRICT;
      },
      set(value) {
        this.SET_ALL({
          key: "CUSTOMER_SUBDISTRICT",
          value: value,
        });
      },
    },
    cus_zip: {
      get() {
        return this.GET_QUOTATION.CUSTOMER_ZIPCODE;
      },
      set(value) {
        this.SET_ALL({
          key: "CUSTOMER_ZIPCODE",
          value: value,
        });
      },
    },
    //auto com by Bee
    vCustomer_Name: {
      get() {
        return this.GET_QUOTATION.CUSTOMER_NAME;
      },
      set(value) {
        this.SET_ALL({
          key: "CUSTOMER_ID",
          value: value.NEWCUSTOMER_ID,
        });
      },
    },
    vCustomer_Tax: {
      get() {
        return this.GET_QUOTATION.CUSTOMER_TAX_ID;
      },
      set(value) {
        this.SET_ALL({
          key: "CUSTOMER_TAX_ID",
          value: value,
        });
      },
    },
    vCustomer_Branch: {
      get() {
        return this.GET_QUOTATION.CUSTOMER_BRANCH;
      },
      set(value) {
        this.SET_ALL({
          key: "CUSTOMER_BRANCH",
          value: value,
        });
      },
    },
  },

  created() {
    const _this = this
    this.checkReciept = "WR"
    this.price_op = this.pricing[0]
    let con_cat = this.GET_QUOTATION.CONTRACT_CATEGORY
   // this.SET_ALL({ key: "REMARK", value: "โอนเงินชำระเงินค่าบริการ\nธนาคารทหารไทย\n599-1-00785-6\n${this.$AppName.CoLtd}", });
    if (!this.$store.getters['Quotation/IS_EDIT']) {
      this.quotationHeader();

    } else {
      this.isEdit = true
      this.listEditQuotation()
    }


    setTimeout(() => {
      this.isVat3 = _this.GET_QUOTATION['ISVAT2'] == 1 ? true : false

    }, 1000)
    this.$token_api
      .get("/list-customer")
      .then((response) => {
        this.list_customer = response.data.data;
      })
      .catch((err) => { });
    this.list_product();

  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
      SET_ALL: "Quotation/SET_ELEMENT",
      MERGE_ALL: "Quotation/MERGE_ALL_ELEMENT",
      SET_PRO_ALL: "Quotation/SET_PRODUCT_LIST",
    }),
    getPreviousRoute(from) {
      this.previousRoute = from
    },
    genEmailDetail() {
      this.Eheader = 'เอกสารเสนอราคา ' + this.header + ''
      this.Emessage = `เรียน  ${this.vCustomer_Name}${'\n'}${'\n'}${this.$AppName.limited_company} ได้แนบเอกสาร เลขที่ ${this.header} มาให้ในอีเมลนี้${'\n'}${'\n'}กรุณาคลิกที่ไฟล์แนบ เพื่อดาวน์โหลดเอกสารของคุณ${'\n'}${'\n'}ด้วยความเคารพ ${this.$AppName.limited_company}`
    },
    onMove(item) {
      //console.log(item);
      this.SET_PRO_ALL(item)
      //api update
    },
    async sendemail() {
      const _this = this
      _this.LOADER(true)
      let data = this.GET_QUOTATION
      data.QUOTATION_ID = this.header
      data.DOC_DATE = moment(data.CREATED_AT).format("DD/MM/YYYY")
      data.TOTAL_PRICE = this.summary
      data.TVAT_VALUE = this.onlyVat7
      data.TOTAL = this.totalVat7
      let product = this.$store.getters["Quotation/GET_PRODUCT"]
      let quotation_list = {
        QUOTATION_ID: this.header,
        DATA: data,
        PACKAGE: this.$store.getters["Quotation/GET_PRODUCT"],
      };
      let email_obj = {
        QUOTATION_ID: this.header,
        email_sender: this.Esender,
        email_reciever: this.Ereciever,
        email_header: this.Eheader,
        email_content: this.Emessage,
        pdf_file: "",
        file_name: ""
      }
      this.$token_api.post("/insert-duplicate-quotation", quotation_list)
        .then((response) => {
          this.$token_api.post("/send-quotation-email", email_obj)
            .then((response) => {
              this.$swal({
                title: "สำเร็จ",
                text: "สร้างใบเสนอราคาสำเร็จ",
                timer: 2000,
                icon: "success"
              }).then((res) => {
                // this.$store.dispatch("Quotation/reset");
                // this.quotationHeader()

                this.LOADER(false)
                this.dialog = false
                this.back()
              });
            }).catch((err) => {
              this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
              this.LOADER(false)
            });
        })

        .catch((err) => {
          this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
          this.LOADER(false)
        });
      // pdfMake.vfs = pdfFonts.pdfMake.vfs;
      // pdfMake.fonts = {
      //   THSarabunNew: {
      //     normal: "THSarabunNew.ttf",
      //     bold: "THSarabunNew Bold.ttf",
      //     italics: "THSarabunNew Italic.ttf",
      //     bolditalics: "THSarabunNew BoldItalic.ttf",
      //   },
      //   Roboto: {
      //     normal: "Roboto-Regular.ttf",
      //     bold: "Roboto-Medium.ttf",
      //     italics: "Roboto-Italic.ttf",
      //     bolditalics: "Roboto-MediumItalic.ttf",
      //   },
      // };
      // pdfMake.createPdf(await quotation_pdf(data, product)).getBase64(function (encodedString) {
      //   const formData = new FormData();
      //   formData.append('email_sender', _this.Esender);
      //   formData.append('email_reciever', _this.Ereciever);
      //   formData.append('email_header', _this.Eheader);
      //   formData.append('email_content', _this.Emessage);
      //   formData.append('quotation_pdf', encodedString);
      //   _this.$file_api.post("send-email", formData)
      //     .then((response) => {
      //       _this.save()

      //     }).catch((e) => {
      //       _this.LOADER(false);
      //     })
      //   //b64 = encodedString;

      // });
    },
    async printPdf() {
      this.LOADER(true)
      let isReciept = this.checkReciept == "WR" ? true : false
      let data = this.GET_QUOTATION
      data.CREATED_AT = moment(data.CREATED_AT).format("YYYY-MM-DD")
      data.DOC_DATE = moment(data.CREATED_AT).format("DD/MM/YYYY")
      data.QUOTATION_ID = this.header
      data.TOTAL_PRICE = this.summary
      data.TVAT_VALUE = this.onlyVat7
      data.TOTAL = this.totalVat7
      let product = this.$store.getters["Quotation/GET_PRODUCT"]
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      }
      let quotation_list = {
        QUOTATION_ID: this.header,
        DATA: data,
        PACKAGE: this.$store.getters["Quotation/GET_PRODUCT"],
      };
      this.$token_api
        .post("/insert-duplicate-quotation", quotation_list)
        .then((response) => {
          this.$swal({
            title: "สำเร็จ",
            text: "สร้างใบเสนอราคาสำเร็จ",
            timer: 2000,
            icon: "success"
          }).then(async (res) => {
            pdfMake.createPdf(await quotation_pdf(data, product, isReciept)).open();
            this.LOADER(false)
          });

        })
        .catch((err) => {
          this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
          this.LOADER(false)
        });
    },
    async downloadPdf() {
      this.LOADER(true)
      let data = this.GET_QUOTATION
      data.DOC_DATE = moment(data.CREATED_AT).format("DD/MM/YYYY")
      data.CREATED_AT = moment(data.CREATED_AT).format("YYYY-MM-DD")
      data.QUOTATION_ID = this.header
      data.TVAT_VALUE = this.onlyVat7
      data.TOTAL_PRICE = this.summary
      data.VAT_VALUE = this.onlyVat7
      data.TOTAL = this.totalVat7
      let product = this.$store.getters["Quotation/GET_PRODUCT"]
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };
      let quotation_list = {
        QUOTATION_ID: this.header,
        DATA: data,
        PACKAGE: this.$store.getters["Quotation/GET_PRODUCT"],
      };

      this.$token_api
        .post("/insert-duplicate-quotation", quotation_list)
        .then((response) => {
          this.$swal({
            title: "สำเร็จ",
            text: "สร้างใบเสนอราคาสำเร็จ",
            timer: 2000,
            icon: "success"
          }).then(async (res) => {
            pdfMake.createPdf(await quotation_pdf(data, product)).download(`ใบเสนอราคา_${this.header}.pdf`);
            this.LOADER(false)
          });

        })
        .catch((err) => {
          this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
          this.LOADER(false)
        });

    },
    listEditQuotation() {
      this.LOADER(true)
      let quotation = this.GET_QUOTATION;
      this.$token_api
        .post("/step-quotation-by-customer-id", {
          QUOTATION_ID: quotation.QUOTATION_ID,
        }).then(async (response) => {
          let data = response.data.data;
          if (data.length > 0) {
            const prod_detail = await new Response(data[0].PRODUCT_LIST).json();
            this.MERGE_ALL(data[0])
            this.header = data[0].QUOTATION_ID
            this.SET_PRO_ALL(prod_detail)
            this.LOADER(false);
          } else {
            this.LOADER(false);
          }
        })
        .catch((err) => {
          this.LOADER(false);
        });


    },
    quotationHeader() {
      // let quotation = this.GET_QUOTATION;
      // if (quotation.QUOTATION_ID) {
      //   console.log(quotation.QUOTATION_ID)
      //   this.header = quotation.QUOTATION_ID
      // } else {
      this.$token_api
        .get("/get-quotation-id")
        .then((response) => {
          this.header = response.data.data[0].qtid;
        })
        .catch((err) => { });
      //}
    },
    clearSearch() {
      this.search = "";
    },
    select_combo(i, item) {

      this.product_list[i].PID = item.PID;
      this.product_list[i].NAME = item.NAME;
      this.product_list[i].UNIT = item.UNIT;
      this.product_list[i].DETAIL = item.DETAIL;
      this.product_list[i].PRICE = item.PRICE;
      let vat3 = this.GET_QUOTATION['ISVAT2'];
      let vat7 = this.GET_QUOTATION['ISVAT'];
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
      let product = this.$store.getters["Quotation/GET_PRODUCT"];
      var valueArr = product.map(function (x) { return x.PID });
      var isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx
      });
      if (isDuplicate) {
        this.$swal({
          title: "กรุณากรอกข้อมูลใหม่",
          text: "พบรายการสินค้าซ้ำ",
          timer: 2000,
          icon: "warning"
        }).then((res) => {
          this.$store.dispatch("Quotation/remove_product_list", item);
        });
      }


    },
    list_product() {
      this.$token_api
        .get("/list-product")
        .then((response) => {
          this.product = response.data.data;
          //console.log(response.data.data)
        })
        .catch((err) => { });
    },
    resetPrice() {
      this.onlyVat3 = 0;
      this.onlyVat7 = 0;
      this.summary = 0;
      this.summaryVat3 = 0;
      this.totalVat7 = 0;
      this.exclude_7 = 0;
      this.SET_ALL({
        key: "ISVAT2",
        value: false,
      });
      this.SET_ALL({
        key: "ISVAT",
        value: false,
      });
    },
    change_contract(item) { },
    select_customer(item) {
      //console.log(item)
      this.$token_api
        .post("/get-customer-by-id", { CUSTOMER_ID: item.NEWCUSTOMER_ID })
        .then((response) => {
          let data = response.data.data[0];
          if (response.data.data.length > 0) {
            this.SET_ALL({
              key: "CUSTOMER_TAX_ID",
              value: data.CUSTOMER_TAX_ID,
            });
            this.SET_ALL({
              key: "CUSTOMER_BRANCH",
              value: data.CUSTOMER_BRANCH,
            });
            this.SET_ALL({
              key: "CUSTOMER_ADDRESS",
              value: data.CUSTOMER_ADDRESS,
            });
            this.SET_ALL({
              key: "CUSTOMER_PROVINCE",
              value: data.CUSTOMER_PROVINCE,
            });
            this.SET_ALL({
              key: "CUSTOMER_DISTRICT",
              value: data.CUSTOMER_DISTRICT,
            });
            this.SET_ALL({
              key: "CUSTOMER_SUBDISTRICT",
              value: data.CUSTOMER_SUBDISTRICT,
            });
            this.SET_ALL({
              key: "CUSTOMER_ZIPCODE",
              value: data.CUSTOMER_ZIPCODE,
            });
          }
        })
        .catch((err) => { });
    },
    vat3_option(item) {
      let vat3 = this.GET_QUOTATION['ISVAT2'];
      let vat7 = this.GET_QUOTATION['ISVAT'];
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
    },
    checked_vat7(item) {
      let vat3 = this.GET_QUOTATION['ISVAT2'];
      let vat7 = this.GET_QUOTATION['ISVAT'];
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
    },
    checked_vat3(item) {
      this.isVat3 = item;
      let vat3 = this.GET_QUOTATION['ISVAT2'];
      let vat7 = this.GET_QUOTATION['ISVAT'];
      let p_option = this.vat_option;
      if (item) {
        this.SET_ALL({ key: "VAT_VALUE2", value: "3%" })
      } else {
        this.SET_ALL({ key: "VAT_VALUE2", value: "" })
      }
      this.sumProductValue(vat7, vat3, p_option);
      // console.log(this.onlyVat3)

    },
    price_option(item) {
      this.resetPrice();
      this.$store.dispatch("Quotation/reset_product_list");
      this.vat_option = item;
    },
    sumProductValue(vat7, vat3, p_option) {
      let product = this.$store.getters["Quotation/GET_PRODUCT"];
      let sum = product.reduce(
        (acc, item) => parseFloat(acc) + parseFloat(item.PRICE * item.AMOUT),
        0
      );
      if (p_option == "ราคาไม่รวมภาษี") {
        if (vat7 && !vat3) {
          this.onlyVat7 = (sum * 7) / 100;
          this.totalVat7 = sum + (sum * 7) / 100;
          this.onlyVat3 = 0;
          this.summaryVat3 = 0;
          this.SET_ALL({ key: "VAT_VALUE", value: "7%" })
          this.SET_ALL({ key: "VAT_VALUE2", value: "" })
        } else if (!vat7 && vat3) {
          this.onlyVat3 = (sum * parseFloat(this.vat3_value)) / 100;
          this.onlyVat7 = 0;
          this.totalVat7 = sum;
          this.SET_ALL({ key: "VAT_VALUE", value: "" })
          this.SET_ALL({ key: "VAT_VALUE2", value: this.vat3_value })
          this.summaryVat3 = parseFloat(this.totalVat7) - parseFloat(this.onlyVat3);
        } else if (vat7 && vat3) {

          this.onlyVat3 = (sum * parseFloat(this.vat3_value)) / 100;
          this.onlyVat7 = (sum * 7) / 100;
          this.totalVat7 = sum + (sum * 7) / 100;
          this.summaryVat3 = parseFloat(this.totalVat7) - parseFloat(this.onlyVat3);
          this.SET_ALL({ key: "VAT_VALUE", value: "7%" })
          this.SET_ALL({ key: "VAT_VALUE2", value: this.vat3_value })
          console.log(this.vat3_value);
        } else {
          this.onlyVat3 = 0;
          this.onlyVat7 = 0;
          this.totalVat7 = sum;
          this.SET_ALL({ key: "VAT_VALUE", value: "" })
          this.SET_ALL({ key: "VAT_VALUE2", value: "" })
        }
        this.summary = sum;
      } else {
        if (vat3) {

          this.onlyVat3 = (sum * parseFloat(this.vat3_value)) / 100;
          this.onlyVat7 = (sum * 7) / 100;
          this.totalVat7 = sum;
          this.exclude_7 = parseFloat(sum) - parseFloat(this.onlyVat7);
          this.summaryVat3 =
            parseFloat(this.onlyVat3) + parseFloat(this.exclude_7);
        } else {
          this.onlyVat7 = (sum * 7) / 100;
          this.totalVat7 = sum;
          this.exclude_7 = parseFloat(sum) - parseFloat(this.onlyVat7);
          this.onlyVat3 = 0;
          this.summaryVat3 = 0;
        }
        this.summary = sum;
      }

      return sum;
    },
    sumCol(index) {
      let product = this.$store.getters["Quotation/GET_PRODUCT"];
      return parseFloat(product[index].PRICE * product[index].AMOUT);
    },
    total_noVat() {
      return this.sumProductValue();
    },
    changeUnit() {
      let vat3 = this.GET_QUOTATION['ISVAT2'];
      let vat7 = this.GET_QUOTATION['ISVAT'];
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
    },
    changePrice() {
      let vat3 = this.GET_QUOTATION['ISVAT2'];
      let vat7 = this.GET_QUOTATION['ISVAT'];
      let p_option = this.vat_option;
      this.sumProductValue(vat7, vat3, p_option);
    },
    add_product() {

      this.$store.dispatch("Quotation/add_product_list", {
        INDEX: 0,
        NAME: "",
        DETAIL: "",
        AMOUT: 1,
        UNIT: "",
        PRICE: 0,
        TOTAL_PRICE: 0,
      });
    },
    async delete_product(item) {
      this.$swal({
        title: "ต้องการลบสินค้าหรือไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then(async (result) => {
        if (result.value) {
          await this.$token_api.delete("/delete-quotation-product", { data: { QUOTATION_ID: this.header, PRODUCT_ID: item.PID } })
          this.$store.dispatch("Quotation/remove_product_list", item);

        }
      })


    },
    back() {
      // console.log(process.env.host)
      let _from = this.previousRoute;
      if (_from) {
        window.location.href = `${this.$global_link}${_from.path}`;
      } else {
        window.location.href = `${this.$global_link}`;
      }
    },
    save() {
      let quotation = this.GET_QUOTATION;
      this.LOADER(true)
      quotation.CREATED_AT = moment(quotation.CREATED_AT).format("YYYY-MM-DD")
      quotation.DOC_DATE = moment(quotation.CREATED_AT).format("DD/MM/YYYY")
      quotation.QUOTATION_ID = this.header
      quotation.TVAT_VALUE = this.onlyVat7
      this.SET_ALL({ key: "DOC_STATUS", value: "อนุมันติ" })
      let quotation_list = {
        QUOTATION_ID: this.header,
        DATA: quotation,
        PACKAGE: this.$store.getters["Quotation/GET_PRODUCT"],
      };
      this.$token_api.post("/insert-duplicate-quotation", quotation_list)
        .then((response) => {
          this.$swal({
            title: "สำเร็จ",
            text: "สร้างใบเสนอราคาสำเร็จ",
            timer: 2000,
            icon: "success"
          }).then((res) => {
            this.$store.dispatch("Quotation/reset");
            this.quotationHeader()
            this.LOADER(false)
            this.dialog = false
            this.back()
          });

        })
        .catch((err) => {
          this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
          this.LOADER(false)
        });
      // this.$token_api
      //   .post("/insert-quotation", quotation)
      //   .then((response) => {
      //     this.$token_api
      //       .post("/insert-quotation-product", quotation_list)
      //       .then((response) => {
      //         this.$swal({
      //           title: "สำเร็จ",
      //           text: "สร้างใบเสนอราคาสำเร็จ",
      //           timer: 2000,
      //           icon: "success"
      //         }).then((res) => {
      //           this.$store.dispatch("Quotation/reset");
      //           this.quotationHeader()
      //           this.LOADER(false)
      //           this.dialog = false
      //           this.back()
      //         });

      //       })
      //       .catch((err) => {
      //         this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
      //         this.LOADER(false)
      //       });

      //   })
      //   .catch((err) => {
      //     this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
      //     this.LOADER(false)
      //   });
    },
    edit() {
      this.LOADER(true)
      let quotation = this.GET_QUOTATION;
      quotation.CREATED_AT = moment(quotation.CREATED_AT).format("YYYY-MM-DD")
      quotation.DOC_DATE = moment(quotation.CREATED_AT).format("DD/MM/YYYY")
      quotation.QUOTATION_ID = this.header
      quotation.TVAT_VALUE = this.onlyVat7
      let quotation_list = {
        QUOTATION_ID: this.header,
        DATA: quotation,
        PACKAGE: this.$store.getters["Quotation/GET_PRODUCT"],
      };
      this.$token_api.post("/insert-duplicate-quotation", quotation_list)
        .then((response) => {
          this.$swal({
            title: "สำเร็จ",
            text: "แก้ไขใบเสนอราคาสำเร็จ",
            timer: 2000,
            icon: "success"
          }).then((res) => {
            this.$store.dispatch("Quotation/reset");
            this.LOADER(false)
            this.back()
          });

        })
        .catch((err) => {
          this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
          this.LOADER(false)
        });
      // let quotation_list = {
      //   QUOTATION_ID: quotation.CUSTOMER_ID,
      //   PACKAGE: this.$store.getters["Quotation/GET_PRODUCT"],
      // };
      // this.$token_api
      //   .post("/update-quotation", quotation)
      //   .then((response) => {
      //     if (response.data.data.length > 0) {
      //       this.$token_api
      //         .post("/update-quotation-product", quotation_list)
      //         .then((response) => {
      //           this.$swal("แก้ไขใบเสนอราคาสำเร็จ", "สำเร็จ", "success");
      //           this.$store.dispatch("Quotation/reset");
      //           this.LOADER(false)
      //           this.back()
      //           //this.quotationHeader()
      //         })
      //         .catch((err) => {
      //           this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
      //           this.LOADER(false)
      //         });
      //     }
      //   })
      //   .catch((err) => {
      //     this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
      //     this.LOADER(false)
      //   });
    }
  },

};
</script>

